import axios from 'axios';

const api = '/api/products';

export const getProducts = params => {
  const queryParams = params
    ? Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&')
    : '';

  return axios.get(`${api}?${queryParams}&cacheBuster=${new Date().getTime()}`);
};

export const getById = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const create = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const update = data => {
  return axios.put(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const getProductsByCompany = companyId => {
  return axios.get(`${api}/byCompany?companyId=${companyId}&cacheBuster=${new Date().getTime()}`);
};

export const getProductsByCompanyIds = ids => {
  return axios.get(`${api}/byCompanies?companies=${ids}&cacheBuster=${new Date().getTime()}`);
};

export const getProductById = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};
